import { render, staticRenderFns } from "./Kycs.vue?vue&type=template&id=3e612ba8&"
import script from "./Kycs.vue?vue&type=script&lang=js&"
export * from "./Kycs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports